import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom'
import * as serviceWorker from './serviceWorker';
import { ThemeProvider } from '@material-ui/core/styles'
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { AuthProvider } from 'react-oidc-context';
import { oidcConfig } from './config/authConfig';
import KeycloakTokenManager from './components/KeycloakTokenManager';
import { store, persistor } from './store';

import theme from './lib/Theme.js'

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Router>
            <KeycloakTokenManager />
            <ThemeProvider theme={theme}>
                <App />
            </ThemeProvider>
          </Router>
        </PersistGate>
      </Provider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
